import { lazily } from 'react-lazily'
/**
 * Layouts
 */
import { SingleAction } from 'layout'
import Guard from 'guards/Guard'

const { RoleCaja } = lazily(() => import('pages/home'))

const {
  ViewAuthorizedProceedingsFiles,
  ViewProceedingDetails,
} = lazily(() => import('pages/students'))

const {
  ViewReceivedProceedingsFiles
} = lazily(() => import('pages/proceedings'))
/**
 * Layouts
 */
const LAYOUTS = {
  singleAction: SingleAction,
}

const basePath = '/dashboard/caja'

const cajaRoutes = [
  {
    name: 'role-caja-home',
    path: basePath,
    element: RoleCaja,
    suspenseFallback: null,
    childs: [
      {
        element: ViewReceivedProceedingsFiles,
        guard: Guard,
        guardProps: { allowedRoles: ['Caja'] },
        homeForRole: ['Caja'],
        name: 'ver-expedientes-recibidos',
        path: 'expedientes-recibidos',
        index: true,
        childs: [
          {
            name: 'detalle-expediente-pendiente',
            path: ':proceedingId',
            layoutProps: { title: 'Detalle del lote' },
            layout: LAYOUTS.singleAction,
            element: ViewProceedingDetails,
          },
        ],
      },
      {
        element: ViewAuthorizedProceedingsFiles,
        guard: Guard,
        guardProps: { allowedRoles: ['Caja'] },
        name: 'ver-expedientes-autorizados',
        path: 'expedientes-autorizados',
        childs: [
          {
            name: 'detalle-expediente-authorizado',
            path: ':proceedingId',
            layoutProps: { title: 'Detalle del lote' },
            layout: LAYOUTS.singleAction,
            element: ViewProceedingDetails,
          },
        ],
      },
    ],
  },
]
export default cajaRoutes